import { SkeletonRowProps } from './type';
import { getUniqueKey } from '../../../utils';
import {
  SkeletonCellStyled,
  SkeletonContainerStyled,
  skeletonCellPadding,
  SkeletonRowStyled,
} from './styled';

const SkeletonRow = ({ ...props }: SkeletonRowProps) => {
  const { items, height: heightProp, style } = props;

  const getWidth = (width: number): number => {
    const widthValue = (width || 75) - skeletonCellPadding.horizontal * 2;
    const minWidth = 75 - skeletonCellPadding.horizontal * 2;
    return widthValue > 0 ? widthValue : minWidth;
  };
  const getHeight = (height: number): number => {
    const heightValue = (height || 44) - skeletonCellPadding.vertical * 2;
    const minHeight = 44 - skeletonCellPadding.vertical * 2;
    return heightValue > 0 ? heightValue : minHeight;
  };
  return (
    <SkeletonRowStyled {...props}>
      {Object.values(items).map(({ width }: { width?: number }, index) => {
        const widthValue = getWidth(width);
        const heightValue = getHeight(heightProp);
        return (
          <SkeletonCellStyled
            height={heightValue}
            width={widthValue}
            key={getUniqueKey()}
            data-testid={`skeleton-cell-${index}`}
            style={{ ...style }}
          >
            <SkeletonContainerStyled width={widthValue} height={heightValue} />
          </SkeletonCellStyled>
        );
      })}
    </SkeletonRowStyled>
  );
};

SkeletonRow.defaultProps = {
  items: {},
  style: {},
};

export default SkeletonRow;
